import PropTypes from 'prop-types';
import React, { Component } from 'sitewide-react';

class RedesignedMentionsPing extends Component {
  constructor(props) {
    super(props);
    this.closeRef = React.createRef();
  }

  createCloseTooltip(pingName) {
    return (e) => {
      e.preventDefault();
      $.ajax({
        type: 'POST',
        url: $r.record_ping_dismissal_api_v0_onsite_pings_path({
          subdomain_param: 'api',
        }),
        contentType: 'application/json',
        processData: false,
        data: JSON.stringify({
          ping_name: pingName,
        }),
      });

      const pingContainer = document.getElementById('onsite-ping');
      pingContainer.classList.remove('visible');

      let event;
      if (typeof Event === 'function') {
        event = new Event('dismiss');
      } else {
        event = document.createEvent('Event');
        event.initEvent('dismiss', true, true);
      }
      pingContainer.dispatchEvent(event);
    };
  }

  getBody() {
    // Not implemented
  }

  getUpgradeURL() {
    // Not Implemented
  }

  getButtonText() {
    return 'View Your Mentions ▸';
  }

  renderIcon() {
    if (this.props.profilePictureUrl) {
      return (
        <div
          className="profile-picture-wrapper"
          style={{ backgroundImage: `url(${this.props.profilePictureUrl})` }}
        />
      );
    } else {
      return (
        <div className="icon-wrapper">
          <img src={$image_url('onsite_pings/mentions-icon.png')} />
        </div>
      );
    }
  }

  renderUserInfo() {
    return (
      <div className="user-info">
        <div className="user-name">{this.props.userDisplayName}</div>
        <div className="affiliation">{this.props.userAffiliation}</div>
      </div>
    );
  }

  renderTopSection() {
    return (
      <div className="ping-header">
        <div className="close-button-wrapper">
          <button
            ref={this.closeRef}
            className="close-button"
            onClick={this.createCloseTooltip(this.props.pingName)}
          >
            ×
          </button>
        </div>
        <div className="icon-and-info-wrapper">
          {this.renderIcon()}
          {this.renderUserInfo()}
        </div>
      </div>
    );
  }

  renderMainSection() {
    return (
      <div className="ping-main">
        <div className="title">MENTIONS UPDATE</div>
        {this.getBody()}
      </div>
    );
  }

  redirectToUpgradeUrl = () => {
    $.ajax({
      type: 'POST',
      url: $r.record_ping_clickthrough_api_v0_onsite_pings_path({
        subdomain_param: 'api',
      }),
      contentType: 'application/json',
      processData: false,
      data: JSON.stringify({
        ping_name: this.props.pingName,
      }),
    });

    window.location = this.getUpgradeURL();
  };

  onBodyClick = (event) => {
    if (event.target === this.closeRef.current) return;
    this.redirectToUpgradeUrl(); // TODO Replace with anchor tag.
  };

  renderButton() {
    return (
      <div className="ping-button">
        <button className="Button Button--round">{this.getButtonText()}</button>
      </div>
    );
  }

  renderBasePing() {
    return (
      <div
        className="redesigned-ping-wrapper u-clickable"
        onClick={this.onBodyClick}
      >
        {this.renderTopSection()}
        {this.renderMainSection()}
        {this.renderButton()}
      </div>
    );
  }

  renderMobilePing() {
    return <div className="mobile-popover">{this.renderBasePing()}</div>;
  }

  render() {
    if ($a.isSmallScreen()) {
      return this.renderMobilePing();
    } else {
      return this.renderBasePing();
    }
  }
}

RedesignedMentionsPing.propTypes = {
  pingName: PropTypes.string.isRequired,
  userDisplayName: PropTypes.string.isRequired,
  userAffiliation: PropTypes.string,
  profilePictureUrl: PropTypes.string,
};

export default RedesignedMentionsPing;
